
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import FileInput from '@devsisters/ui-careers/lib/FileInput';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"fileinput"}}>{`FileInput`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { FileInput } from '@devsisters/ui/careers';
// 또는 import FileInput from '@devsisters/ui-careers/lib/FileInput';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<State initialState={{ value: null }}>\n  {({ state, setState }) => (\n    <FileInput\n      style={{ fontSize: \'16px\' }}\n      value={state.value}\n      onChange={value => setState({ value })}\n      error={!state.value ? \'에러 메세지\' : undefined}\n      accept=\".png,.jpg\"\n      comments={[\n        \'이 곳에는 파일 첨부 주의사항을 적습니다.\',\n        \'예를 들자면...\',\n        \'png 파일이나 jpg 파일만 올려주세요! ..같은?\',\n      ]}\n    />\n  )}\n</State>'} __scope={{props: this ? this.props : props,State,FileInput}}>
  <State initialState={{ value: null }}>
    {({ state, setState }) => (
      <FileInput
        style={{ fontSize: '16px' }}
        value={state.value}
        onChange={value => setState({ value })}
        error={!state.value ? '에러 메세지' : undefined}
        accept='.png,.jpg'
        comments={[
          '이 곳에는 파일 첨부 주의사항을 적습니다.',
          '예를 들자면...',
          'png 파일이나 jpg 파일만 올려주세요! ..같은?',
        ]}
      />
    )}
  </State>
</Playground>
           </MDXTag>
  }
}
  